import { render, staticRenderFns } from "./totals.vue?vue&type=template&id=14b9ae38"
import script from "./totals.vue?vue&type=script&lang=js"
export * from "./totals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports